import TanfundPage from './TanfundPage';
export default TanfundPage;
